var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.mostrarModalConfirmacao
        ? _c("ConfirmacaoModal", {
            attrs: {
              showDialog: _vm.mostrarModalConfirmacao,
              tituloModal: _vm.tituloModalConfirmacao,
              textoModal: _vm.textoModalConfirmacao,
              btnConfirmarEmit: _vm.btnConfirmarModalConfirmacao,
              esconderCancelar: _vm.esconderCancelar,
              btnConfirmar: _vm.btnConfirmarLabel
            },
            on: {
              invalidarInstrumento: _vm.invalidarInstrumento,
              fecharModal: function($event) {
                _vm.mostrarModalConfirmacao = false
                _vm.esconderCancelar = false
              }
            }
          })
        : _vm._e(),
      _c(
        "v-card",
        { staticClass: "pa-3 card-instrumento" },
        [
          _c(
            "v-row",
            [
              _c("v-col", [
                _c("h4", { staticClass: "bold" }, [
                  _vm._v("Instrumento de Protesto")
                ])
              ])
            ],
            1
          ),
          !_vm.instrumentoProtesto
            ? _c(
                "v-row",
                { staticClass: "d-flex h-90" },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "d-flex justify-center align-center h-90",
                      attrs: { sm: "12", md: "12", lg: "12" }
                    },
                    [
                      _c(
                        "v-alert",
                        {
                          attrs: {
                            prominent: "",
                            icon: _vm.getIconeAlerta(),
                            shaped: "",
                            type: _vm.getTipoAlerta()
                          }
                        },
                        [
                          _vm._v(" " + _vm._s(_vm.getTextoAlerta()) + " "),
                          _vm.permitirSolicitarInstrumento()
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "white--text ml-2",
                                  attrs: {
                                    color: "#46a6f5",
                                    fab: "",
                                    dark: "",
                                    small: ""
                                  },
                                  on: { click: _vm.solicitaInstrumentoProt }
                                },
                                [
                                  _c("v-icon", { staticClass: "ma-2" }, [
                                    _vm._v(
                                      "mdi-arrow-top-right-bold-box-outline"
                                    )
                                  ])
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _c(
                "v-row",
                { staticClass: "d-flex align-center mt-0 py-3" },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "py-0",
                      attrs: { cols: "12", sm: "4", md: "4" }
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          outlined: "",
                          dense: "",
                          label: "Nome Anexo",
                          required: "",
                          readonly: "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.instrumentoProtesto.ds_anexo_nome,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.instrumentoProtesto,
                              "ds_anexo_nome",
                              $$v
                            )
                          },
                          expression: "instrumentoProtesto.ds_anexo_nome"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ml-3 white--text",
                      attrs: {
                        loading: _vm.baixandoInstrumento,
                        color: "green",
                        width: "120px"
                      },
                      on: { click: _vm.baixarInstrumentos }
                    },
                    [_vm._v("BAIXAR ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ml-3 white--text",
                      staticStyle: { "background-color": "green" },
                      attrs: {
                        width: "200px",
                        loading: _vm.baixandoInstrumento
                      },
                      on: { click: _vm.baixarInstrumentosKitAjuizamento }
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [
                        _vm._v(" mdi-download ")
                      ]),
                      _vm._v(" Kit Ajuizamento ")
                    ],
                    1
                  ),
                  _vm.superUsuario
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "ml-3 white--text",
                          attrs: {
                            loading: _vm.baixandoInstrumento,
                            color: "orange darken-3",
                            width: "120px"
                          },
                          on: { click: _vm.modalInvalidarInstrumento }
                        },
                        [_vm._v("INVALIDAR ")]
                      )
                    : _vm._e()
                ],
                1
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }